import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { ProjectAttributesService } from 'src/app/services/project-attributes.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
@Component({
  selector: 'app-add-admin',
  templateUrl: './add-admin.component.html',
  styleUrls: ['./add-admin.component.scss']
})
export class AddAdminComponent implements OnInit {

  isEditMode = false;
  formTitle = '';
  submitted = false
  selectedStatus: any;
  empData;
  status = ['Active', 'Inactive']
  traineeTypes = ['Yes', 'No']
  empForm: FormGroup;
  hide = false;
  public constructor(
    private formBuilder: FormBuilder,
    private notifier: NotifierService,
    private route: ActivatedRoute,
    private location: Location,
    private spinner: NgxSpinnerService,
    private employeeService: EmployeeService,
    private stationService: StationService,
    private authenticationService: AuthenticationService,
    private projectAttrService: ProjectAttributesService) {
  }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id') != null) {
      this.formTitle = "Update Admin Profile";
      this.isEditMode = true;
      this.getEmployeeById(this.route.snapshot.paramMap.get('id'));
    } else {
      this.formTitle = "Add Admin Profile"
    }
    this.initAddEmployeeForm();
  }

  initAddEmployeeForm() {
    this.empForm = new FormGroup({
      role: new FormControl('', Validators.required),
      fname: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.minLength(3), Validators.maxLength(20)
      lname: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.minLength(3), Validators.maxLength(20)
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      password: new FormControl('Superadmin@', Validators.compose([Validators.required, Validators.minLength(6)])),
      status: new FormControl(''),
    });
  }

  initUpdateEmployeeForm() {
    this.empForm = this.formBuilder.group({
      fname: new FormControl(this.empData.firstname, Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.minLength(3), Validators.maxLength(20)
      lname: new FormControl(this.empData.lastname, Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.minLength(3), Validators.maxLength(20)
      email: new FormControl(this.empData.email, Validators.compose([Validators.required, Validators.email])),
      password: new FormControl(this.empData.password, Validators.compose([Validators.required, Validators.minLength(6)])),
      status: new FormControl(this.selectedStatus, Validators.required),
       });
  }


  getEmployeeById(emp_id) {
    this.spinner.show();
    this.employeeService.getSuperAdminDetails(emp_id).subscribe(employee => {
      this.empData = employee['result'];
      this.selectedStatus = this.empData.status ? this.status[0] : this.status[1];
      this.spinner.hide();
      this.initUpdateEmployeeForm();
    });
  }

  validation_messages = {
    'status': [
      { type: 'required', message: 'status  is required.' }
    ],
    'fname': [
      { type: 'required', message: 'First Name is required.' },
    //  { type: 'minlength', message: 'First name must be 3 characters long.' },
      { type: 'pattern', message: 'Please enter alphabets only.' },
    //  { type: 'maxlength', message: 'First name should not be more then 20 characters long.' }
    ],
    'lname': [
      { type: 'required', message: 'Last Name is required.' },
    //  { type: 'minlength', message: 'Last name must be 3 characters long.' },
      { type: 'pattern', message: 'Please enter alphabets only.' },
     // { type: 'maxlength', message: 'Last name should not be more then 20 characters long.' }

    ],
    'password': [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be 6 characters long.' },

    ],
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Email format must be similar to joe@abc.com' },
    ]
  }

  get f(): any {
    return this.empForm.controls;
  }

  onBack() {
    this.location.back();
  }

  onRest() {
    this.submitted = false
    this.empForm.reset();
    this.f.password.setValue("WelcomeATS")

  }

  myFunction() {
    this.hide = !this.hide;
  }

  validateEmployee() {
   
    if (this.f.fname.errors) {
      this.notifier.notify('warning', 'Please enter first name')
      return false;
    }
    if (this.f.lname.errors) {
      this.notifier.notify('warning', 'Please enter last name')
      return false;
    }

    if (this.f.email.errors) {
      this.notifier.notify('warning', 'Please enter email id')
      return false;
    }
   
    if (this.isEditMode && this.f.status.errors) {
      this.notifier.notify('warning', 'Please select employee status')
      return false;
    }
  }


  onAddEmployee(values) {
    this.submitted = true
    this.validateEmployee();
    var data = {
      "firstname": values.fname,
      "lastname": values.lname,
      "preferred_name": values.fname + " " + values.lname,
      "email": values.email,
      "password": values.password,
    }

    this.spinner.show()
    this.employeeService.addAdminProfile(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
       this.initAddEmployeeForm();
       this.notifier.notify('success', res['message']);
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
    })
  }


  onUpdateEmployee(values) {
    this.submitted = true
    this.validateEmployee()
    if (this.empForm.invalid) {
      return;
    }
    var data = {
      "id": this.empData.id,
      "firstname": values.fname,
      "lastname": values.lname,
      "preferred_name": this.empData.preferred_name,
      "email": values.email,
      "password": this.empData.password
    }

    if (values.status != this.status[0]) {
      data["status"] = false;
      data["terminated_date"] = moment().format('MM/DD/YYYY HH:mm')
    } else {
      data["status"] = true;
      data["terminated_date"] = null
    }
    this.spinner.show()
    this.employeeService.updateAdminProfile(data).subscribe(res => {
      this.spinner.hide()
      if (res['status']) {
        this.notifier.notify('success', "Admin details updated successfully...")
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

}
